import { CollectDebugInfoFn } from './types';
import { meetingStore } from '@/store/meeting';

export const collectEndpointCount: CollectDebugInfoFn = () => ({
  endpointCount: Object.values(meetingStore.getState().meeting?.endpointsMap.value || {}).length,
});
